<template>
  <section class="sec01">
    <div class="inner" v-show="items.length > 0">
      <!--슬라이드 배너-->
      <div class="visual_bnr">
        <swiper tag="ul" ref="mySwiper" :options="swiperOption">
          <swiper-slide
            tag="li"
            class="visual_bnr_li"
            v-for="(item, index) in items"
            :key="item"
          >
            <div
              :style="{
                backgroundImage: $ConstCode.getImagePath(item.imagePath)
              }"
              style="height: 480rem"
            ></div>
            <div class="blur" :style="`background-image: url('${$ConstCode.getImagePath(item.imagePath)}')`"></div>
            <div class="img_wrap" @click="fnMove(item.url)">
              <img :src="$ConstCode.getImagePath(item.imagePath)" alt="" />
            </div>
            <div class="visual_bnr_pager">
              <div class="number">
                {{ index + 1 }}<span class="of">&#32;/&#32;3</span>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="visual_bnr_pager">
          <button class="pager_btn prev" ></button>
          <button class="pager_btn next"></button>
        </div>
      </div>
      <!--//슬라이드 배너-->
    </div>
  </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'main-banner-index',
  components: { Swiper, SwiperSlide },
  data: function() {
    return {
      swiperOption: {
        slidesPerView: 1,
        slideToClickedSlide: true,
        navigation: {
          nextEl: '.pager_btn.next',
          prevEl: '.pager_btn.prev'
        },
        autoplay: {
          delay: 3000
        }
      },
      items: []
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    userData() {
      return this.$store.getters['user/getUserData']
    }
  },
  methods: {
    onSlideChange: function(index) {
      console.log('onSlideChange', index)
    },
    fetchData: async function() {
      const res = await this.$MainSvc.getListBoxTopBanner()
      if (res.code === 1) {
        this.items = res.entity.list
      }
    },
    fnMove: function(link) {
      console.log(link)
      if (this.$Util.isEmpty(link)) return false
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped></style>
